<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descricao"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="v-descricao">
                <b-form-input
                  id="v-descricao"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Descrição"
                  data-cy="description-input"
                  :disabled="!canEditOrInsert"
                />
                <small data-cy="v-description-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="plano de conta"
              rules="required"
            >
              <b-form-group label="Plano de Conta" label-for="v-plano-conta">
                <v-select
                  v-model="form.planoDeConta.id"
                  :reduce="(comboPlanoConta) => comboPlanoConta.id"
                  label="classe"
                  :options="comboPlanoConta"
                  :state="errors.length > 0 ? false : null"
                  data-cy="plano-conta-select"
                  :disabled="!canEditOrInsert"
                />
                <small data-cy="v-plano-conta-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <hr />
            <h6 class="mb-1 text-primary">
              Regras de Encargos e Juros (Atraso)
            </h6>
          </b-col>

          <b-col md="6">
            <b-form-group label="Tem Multa?" label-for="v-temMulta">
              <b-form-checkbox
                id="v-temMulta"
                v-model="form.temMulta"
                name="check-button"
                switch
                :disabled="
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
              >
                {{ form.temMulta ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="% Multa" label-for="v-percentualMulta">
              <b-form-input
                id="v-percentualMulta"
                v-model="form.percentualMulta"
                type="number"
                step="0.01"
                :disabled="
                  !form.temMulta ||
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
                placeholder="0.00"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Tem Juro Diário?" label-for="v-temJuro">
              <b-form-checkbox
                id="v-temJuro"
                v-model="form.temJuro"
                name="check-button"
                switch
                :disabled="
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
              >
                {{ form.temJuro ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="% Juro Diário"
              label-for="v-percentualJuroDiario"
            >
              <b-form-input
                id="v-percentualJuroDiario"
                v-model="form.percentualJuroDiario"
                type="number"
                step="0.01"
                :disabled="
                  !form.temJuro ||
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
                placeholder="0.00"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <hr />
            <h6 class="mb-1 text-primary">Regras de Desconto e Antecipação</h6>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Permite Desconto?"
              label-for="v-permiteDesconto"
            >
              <b-form-checkbox
                id="v-permiteDesconto"
                v-model="form.permiteDesconto"
                name="check-button"
                switch
                :disabled="
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
              >
                {{ form.permiteDesconto ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="% Desconto Máximo"
              label-for="v-percentualDescontoMax"
            >
              <b-form-input
                id="v-percentualDescontoMax"
                v-model="form.percentualDescontoMax"
                type="number"
                step="0.01"
                :disabled="
                  !form.permiteDesconto ||
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
                placeholder="0.00"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Permite Antecipação?"
              label-for="v-permiteAntecipacao"
            >
              <b-form-checkbox
                id="v-permiteAntecipacao"
                v-model="form.permiteAntecipacao"
                name="check-button"
                switch
                :disabled="
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
              >
                {{ form.permiteAntecipacao ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="% Desc. Antecipação"
              label-for="v-percentualAntecipacao"
            >
              <b-form-input
                id="v-percentualAntecipacao"
                v-model="form.percentualAntecipacao"
                type="number"
                step="0.01"
                :disabled="
                  !form.permiteAntecipacao ||
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
                placeholder="0.00"
              />
            </b-form-group>
          </b-col>

          <!-- Auto-cancellation section -->
          <b-col cols="12">
            <hr />
            <h6 class="mb-1 text-primary">
              Cancelamento Automático por Situação do Registro
            </h6>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Cancela transações pela situação do registro?"
              label-for="v-cancelaTransacoes"
            >
              <b-form-checkbox
                id="v-cancelaTransacoes"
                v-model="form.cancelaTransacoesPorSituacao"
                name="check-button"
                switch
                :disabled="
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
              >
                {{ form.cancelaTransacoesPorSituacao ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col cols="12" v-if="form.cancelaTransacoesPorSituacao">
            <b-form-group
              label="Situações que disparam o cancelamento:"
              label-for="v-situacoesGatilho"
              description="Selecione as situações do registro que devem cancelar as transações em aberto."
            >
              <b-form-checkbox-group
                id="v-situacoesGatilho"
                v-model="form.situacoesGatilhoSelecionadas"
                :options="comboSituacoesRegistro"
                value-field="id"
                text-field="nome"
                stacked
                :disabled="
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') && !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
              />
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import mixinsGlobal from "@/mixins";
import { verificarPermissao } from "@/auth/utils";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("typeOfPaymentReceiptSettingsModule", {
      typeOfPaymentReceipt: (state) => state.typeOfPaymentReceipt,
      comboPlanoConta: (state) => state.comboPlanoConta,
    }),
    ...mapState("combosModule", {
      comboSituacoesRegistro: (state) => state.comboSituacoesRegistro || [],
      comboTaxas: (state) => state.comboTaxas || [],
    }),
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormCheckbox,
    BFormCheckboxGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: "Cadastro de Tipos de Pagamento / Recebimento",
      required,
      form: {
        descricao: "",
        planoDeConta: {
          id: null,
        },
        ativo: true,
        temMulta: false,
        percentualMulta: null,
        temJuro: false,
        percentualJuroDiario: null,
        permiteDesconto: false,
        percentualDescontoMax: null,
        permiteAntecipacao: false,
        percentualAntecipacao: null,
        cancelaTransacoesPorSituacao: false,
        situacoesGatilhoSelecionadas: [],
      },
    };
  },
  mounted() {
    this.$store.dispatch(
      "typeOfPaymentReceiptSettingsModule/loadComboPlanoContas",
    );
    this.$store.dispatch("combosModule/loadComboSituacoesRegistro");
    this.$store.dispatch("combosModule/loadComboTaxas");

    const loaded = JSON.parse(JSON.stringify(this.typeOfPaymentReceipt));
    // Parse comma-separated IDs back to array of numbers for the checkbox-group
    if (loaded.situacoesGatilhoCancelamento) {
      loaded.situacoesGatilhoSelecionadas = loaded.situacoesGatilhoCancelamento
        .split(",")
        .map((id) => parseInt(id.trim(), 10))
        .filter(Boolean);
    } else {
      loaded.situacoesGatilhoSelecionadas = [];
    }
    if (!loaded.taxa) {
      loaded.taxa = { id: null };
    }
    this.form = { ...this.form, ...loaded };
  },
  methods: {
    cancel() {
      this.$emit("cancelar");
      this.cleanObjeto();
      this.$store.dispatch(
        "typeOfPaymentReceiptSettingsModule/resetTypeOfPaymentReceipt",
      );
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          // Serialize array of IDs to comma-separated string before sending
          const payload = {
            ...this.form,
            situacoesGatilhoCancelamento:
              this.form.situacoesGatilhoSelecionadas.length > 0
                ? this.form.situacoesGatilhoSelecionadas.join(",")
                : null,
          };
          if (this.form.id) {
            this.$store
              .dispatch(
                "typeOfPaymentReceiptSettingsModule/editTypeOfPaymentReceipt",
                payload,
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Editar",
                    response.response.data.error,
                  );
                  return;
                }
                this.showMessageSuccess("Editar", "Editado com sucesso!");
                this.$refs.form.reset();
                this.cancel();
              });
          } else {
            this.$store
              .dispatch(
                "typeOfPaymentReceiptSettingsModule/insertNewTypeOfPaymentReceipt",
                payload,
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Inserir",
                    response.response.data.error,
                  );
                  return;
                }
                this.showMessageSuccess("Salvo", "Incluido com sucesso!");
                this.cleanObjeto();
                this.$refs.form.reset();
              });
          }
        }
      });
    },
    cleanObjeto() {
      this.form = {
        descricao: "",
        planoDeConta: {
          id: null,
        },
        ativo: true,
        temMulta: false,
        percentualMulta: null,
        temJuro: false,
        percentualJuroDiario: null,
        permiteDesconto: false,
        percentualDescontoMax: null,
        permiteAntecipacao: false,
        percentualAntecipacao: null,
        cancelaTransacoesPorSituacao: false,
        situacoesGatilhoSelecionadas: [],
        taxa: { id: null },
        deduzirTaxaAutomatica: false,
      };
    },
  },
};
</script>
